import { SetBearerToken } from '@/http/index.js'

export const SetHeaderToken = (token) => SetBearerToken(token)
export const GetLocalToken = () => localStorage.getItem('token')
export const SetLocalToken = (token) => localStorage.setItem('token', token)
export const DeleteLocalToken = () => SetBearerToken('token')
